import { render } from "./DayItem.vue?vue&type=template&id=47e081ee&scoped=true"
import script from "./DayItem.vue?vue&type=script&lang=js"
export * from "./DayItem.vue?vue&type=script&lang=js"

import "./DayItem.vue?vue&type=style&index=0&id=47e081ee&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e081ee"]])

export default __exports__